import type {NativeWorkScope} from '../../protocol/native-envelope';
import type {CaptionTranslationRequest} from '../../protocol/caption-translation-request';
import {boundCaptionTranslationRequest} from '../../protocol/caption-translation-host';
type Store=Pick<Storage,'length'|'key'|'getItem'|'setItem'|'removeItem'>;
const prefix=(scope:NativeWorkScope)=>`waka-caption-translations:v2:${scope.projectId}:${scope.workId}:${scope.surface}:`;
/** Each request owns a key: stale tab snapshots cannot overwrite another request's receipt. */
export function readTranslationRecords(store:Store,scope:NativeWorkScope):CaptionTranslationRequest[]{
 const start=prefix(scope),records:CaptionTranslationRequest[]=[];
 for(let index=0;index<store.length;index++){
  const key=store.key(index);if(!key?.startsWith(start))continue;
  try{const value=boundCaptionTranslationRequest(scope,JSON.parse(store.getItem(key)??'null'));if(key===start+value.requestId)records.push(value);}catch{/* Ignore malformed local metadata. */}
 }
 return records.sort((a,b)=>b.expectedRevision.localeCompare(a.expectedRevision)||a.requestId.localeCompare(b.requestId));
}
export function rememberTranslationRequest(store:Store,scope:NativeWorkScope,raw:CaptionTranslationRequest){
 const request=boundCaptionTranslationRequest(scope,raw),key=prefix(scope)+request.requestId;
 const existing=store.getItem(key);
 if(existing!==null){
  if(JSON.stringify(boundCaptionTranslationRequest(scope,JSON.parse(existing)))!==JSON.stringify(request))throw Error('기존 요청 번호의 내용을 바꿀 수 없습니다.');
 }else{
  if(readTranslationRecords(store,scope).length>=50)throw Error('보관된 조회 기록이 50개입니다. 확인을 마친 기록을 먼저 지워 주세요.');
  store.setItem(key,JSON.stringify(request));
 }
 const records=readTranslationRecords(store,scope);
 if(existing===null&&records.length>50){store.removeItem(key);throw Error('보관된 조회 기록이 50개입니다. 확인을 마친 기록을 먼저 지워 주세요.');}
 return records;
}
export function forgetTranslationRequest(store:Store,scope:NativeWorkScope,raw:CaptionTranslationRequest){
 const request=boundCaptionTranslationRequest(scope,raw);store.removeItem(prefix(scope)+request.requestId);
 return readTranslationRecords(store,scope);
}
